module.exports = __webpack_public_path__ + "assets/7641d4823e2c9aba0e999cb31d8d36dd.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/FeatureTrigger.mp3
 ** module id = 341
 ** module chunks = 0
 **/